var path = 'app/scripts/modules/kubernetes/src/container/securityContext/seLinuxOptionsSelector.component.html';
var html = "<div class=\"sm-label-left\">\n  <b>SELinux Options</b>\n</div>\n<div class=\"row\" ng-repeat=\"field in $ctrl.fields\">\n  <div class=\"col-md-4 sm-label-right\">\n    {{::field.label}}\n    <help-field key=\"{{::field.helpField}}\"></help-field>\n  </div>\n  <div class=\"col-md-4\">\n    <input type=\"text\"\n           class=\"form-control input-sm\"\n           ng-model=\"$ctrl.component.securityContext.seLinuxOptions[field.model]\"/>\n  </div>\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/kubernetes/src/container/securityContext/seLinuxOptionsSelector.component.html
// module id = 1457
// module chunks = 0